<template>
  <v-btn
    class="lead-bottom-control-panel__btn call-controll__btn white--text ml-2 mt-1 mb-1"
    :color="!hold ? 'light-green darken-1' : 'red darken-1'"
    @click="setOnHold"
    >
    <v-icon v-if="hold" color="white">mdi-phone-in-talk</v-icon>
    <v-icon v-else color="white">mdi-phone-paused</v-icon>
    <span class="lead-bottom-control-panel__item-text call-controll__item-text">{{ !hold ? "hold " : "resume" }}</span>
  </v-btn>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "HoldHandler",
  computed: {
    ...mapGetters({
      hold: "conference/hold",
      confParams: "twilio/confParams",
    }),
  },
  methods: {
    ...mapMutations({
      SET_HOLD: "conference/SET_HOLD",
    }),
    setOnHold() {
      this.SET_HOLD(!this.hold);
      this.$axios.post("/call/conference/handle-hold", {
        callSid: this.confParams.callSid,
        conferenceSid: this.confParams.conferenceSid,
        hold: this.hold,
      });
    },
  },
};
</script>

<style>
</style>